<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="收付信息">
              <el-select clearable filterable class="ele-block" v-model="where.account_name" placeholder="请选择">
                <el-option
                  v-for="item in accountNameList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.account_name_value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24">
            <el-form-item label="选择时间">
              <div class="recon-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="recon-stat-bar">
        <span>成功条数(收): {{ summary.in_count }}</span>
        <span>金额(收): {{ summary.in_amount }}</span>
        <span>成功条数(付): {{ summary.out_count }}</span>
        <span>金额(付): {{ summary.out_amount }}</span>
        <span>实际结余: {{ summary.yingli }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="loadData"
        :columns="columns"
        :need-page="false"
        height="calc(100vh - 360px)" />
    </el-card>
  </div>
</template>

<script>
import reconTime from '@/mixins/recon-time';

const EMPTY_SUMMARY = {
  in_count: 0,
  in_amount: '0.00',
  out_count: 0,
  out_amount: '0.00',
  yingli: '0.00'
};

export default {
  name: 'BankRecon',
  mixins: [reconTime],
  data() {
    return {
      columns: [
        { prop: 'in_count', label: '成功条数(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_paymentAmount', label: '金额(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_fees', label: '费率(收)', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'out_count', label: '成功条数(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_paymentAmount', label: '金额(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'yingli', label: '实际结余', minWidth: 110, align: 'center', showOverflowTooltip: true }
      ],
      where: { account_name: undefined, time: null },
      accountNameList: [],
      summary: { ...EMPTY_SUMMARY }
    };
  },
  mounted() {
    this.getResourceName();
  },
  methods: {
    loadData(params, callback) {
      const where = (params && params.where) || this.where || {};
      this.$http
        .get('/Reconciliation/bank', {
          params: {
            account_name: where.account_name || undefined,
            time: where.time || undefined
          }
        })
        .then((res) => {
          if (res.data.code !== 0) {
            this.summary = { ...EMPTY_SUMMARY };
            this.$message.error(res.data.msg);
            callback([]);
            return;
          }
          this.summary = { ...EMPTY_SUMMARY, ...(res.data.summary || {}) };
          callback(Array.isArray(res.data.data) ? res.data.data : []);
        })
        .catch((e) => {
          this.summary = { ...EMPTY_SUMMARY };
          this.$message.error(e.message);
          callback([]);
        });
    },
    reload() {
      this.$refs.table && this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = { account_name: undefined, time: null };
      this.applyTimeQuick('today', true);
    },
    getResourceName() {
      this.$http
        .post('/resourcecolumn/getResourceName')
        .then((res) => {
          if (res.data.code === 0) this.accountNameList = res.data.data || [];
          else this.$message.error(res.data.msg);
        })
        .catch((e) => this.$message.error(e.message));
    }
  }
};
</script>

<style scoped src="@/styles/recon-stat.css"></style>
